import { render, staticRenderFns } from "./GoodsCreate.vue?vue&type=template&id=9606823a"
import script from "./GoodsCreate.vue?vue&type=script&lang=js"
export * from "./GoodsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports